/**
 * Shopify customer and order GraphQL queries
 * Optimized to use direct nodes access instead of edges/node patterns
 */

export const GET_ORDER_HISTORY = `
  query GetOrderHistory($customerAccessToken: String!, $first: Int!, $after: String) {
    customer(customerAccessToken: $customerAccessToken) {
      email
      phone
      numberOfOrders
      orders(first: $first, after: $after, reverse: true) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        nodes {
          id
          orderNumber
          processedAt
          financialStatus
          fulfillmentStatus
          currentTotalPrice {
            amount
            currencyCode
          }
          lineItems(first: 50) {
            nodes {
              title
              quantity
              variant {
                id
                title
                price {
                  amount
                  currencyCode
                }
                image {
                  url
                  altText
                }
                product {
                  id
                  title
                  vendor
                }
                sku
              }
              currentQuantity
              discountAllocations {
                allocatedAmount {
                  amount
                  currencyCode
                }
              }
              discountedTotalPrice {
                amount
                currencyCode
              }
              originalTotalPrice {
                amount
                currencyCode
              }
            }
          }
          shippingAddress {
            firstName
            lastName
            address1
            address2
            city
            province
            country
            zip
            phone
          }
          billingAddress {
            address1
            address2
            city
            country
            countryCode
            firstName
            lastName
            name
            phone
            zip
          }
          currencyCode
          currentSubtotalPrice {
            amount
            currencyCode
          }
          currentTotalDuties {
            amount
            currencyCode
          }
          currentTotalShippingPrice {
            amount
            currencyCode
          }
          discountApplications(first: 10) {
            nodes {
              value {
                ... on MoneyV2 {
                  __typename
                  amount
                  currencyCode
                }
                ... on PricingPercentageValue {
                  __typename
                  percentage
                }
              }
            }
          }
          subtotalPrice {
            amount
            currencyCode
          }
          totalPrice {
            amount
            currencyCode
          }
          totalShippingPrice {
            amount
            currencyCode
          }
          totalTax {
            amount
            currencyCode
          }
        }
      }
    }
  }
`;

export const GET_ORDER_BY_ID = `
  query GetOrderById($customerAccessToken: String!, $orderId: ID!) {
    customer(customerAccessToken: $customerAccessToken) {
      email
      order(id: $orderId) {
        id
        orderNumber
        processedAt
        financialStatus
        fulfillmentStatus
        currentTotalPrice {
          amount
          currencyCode
        }
        lineItems(first: 50) {
          nodes {
            title
            quantity
            variant {
              id
              title
              price {
                amount
                currencyCode
              }
              image {
                url
                altText
              }
              product {
                id
                title
                vendor
              }
              sku
            }
            currentQuantity
            discountAllocations {
              allocatedAmount {
                amount
                currencyCode
              }
            }
            discountedTotalPrice {
              amount
              currencyCode
            }
            originalTotalPrice {
              amount
              currencyCode
            }
          }
        }
        shippingAddress {
          firstName
          lastName
          address1
          address2
          city
          province
          country
          zip
          phone
        }
        billingAddress {
          address1
          address2
          city
          country
          countryCode
          firstName
          lastName
          name
          phone
          zip
        }
        currencyCode
        currentSubtotalPrice {
          amount
          currencyCode
        }
        currentTotalDuties {
          amount
          currencyCode
        }
        currentTotalShippingPrice {
          amount
          currencyCode
        }
        discountApplications(first: 10) {
          nodes {
            value {
              ... on MoneyV2 {
                __typename
                amount
                currencyCode
              }
              ... on PricingPercentageValue {
                __typename
                percentage
              }
            }
          }
        }
        subtotalPrice {
          amount
          currencyCode
        }
        totalPrice {
          amount
          currencyCode
        }
        totalShippingPrice {
          amount
          currencyCode
        }
        totalTax {
          amount
          currencyCode
        }
      }
    }
  }
`;

export const GET_CUSTOMER_PROFILE = `
  query GetCustomerProfile($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id
      email
      firstName
      lastName
      phone
      displayName
      createdAt
      updatedAt
      defaultAddress {
        id
        firstName
        lastName
        company
        address1
        address2
        city
        province
        country
        zip
        phone
      }
      addresses(first: 10) {
        nodes {
          id
          firstName
          lastName
          company
          address1
          address2
          city
          province
          country
          zip
          phone
        }
      }
    }
  }
`;
